module.exports = __webpack_public_path__ + "media/images/illustrations/wave-blue-2-49ac5c96111f06c0af676529bcabe92f.svg";